$(function() {
    var hamburger = document.querySelector('.hamburger');
    var navbar = document.querySelector('.i4-site__navbar');
    var nav = document.querySelector('.i4-site__navbar-nav');
    var body = document.querySelector('body');

    if (hamburger && nav) {
        // toggle navigation state on hamburger click
        hamburger.onclick = function () {
            if (nav.classList.contains('open')) {
                hamburger.classList.remove('is-active');
                navbar.classList.remove('open');
                nav.classList.remove('open');
                body.classList.remove('navbar');
            } else {
                hamburger.classList.add('is-active');
                navbar.classList.add('open');
                nav.classList.add('open');
                body.classList.add('navbar');
            }
        };
    }
});
